import CloseWhiteIcon from 'assets/ver2/icons/close-white-icon.svg';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { DASHBOARD_PREFIX, DESKTOP_MIN_WIDTH } from 'constants';
import useProfile from 'features/profile2.0/hooks/useProfile';
import useCommonStore from 'hooks/useCommonStore';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  cursorPointerMixin,
  fontSize14Mixin,
  fontSize16Mixin,
  paragraph600Mixin,
} from 'styles';

const withShowDocumentUploadReminder = (Component) => {
  const ShowDocumentUploadReminderComponent = (props) => {
    const { t } = useLang();
    const { isProfileStatusPendingDocuments } = useProfile();
    const { isTransactionsEmpty } = useCommonStore();
    const { showPortalModalName } = usePortalModal();

    const handleShowDocumentUploadReminderInformModal = () => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.DOCUMENT_UPLOAD_REMINDER_INFORM_MODAL,
      });
    };

    const [isShowDocumentUploadReminder, setShowDocumentUploadReminder] =
      useState(false);

    const pathShowDocumentUploadReminders = [DASHBOARD_PREFIX];

    useEffect(() => {
      if (!pathShowDocumentUploadReminders.includes(window.location.pathname))
        return;
      if (isTransactionsEmpty) {
        setShowDocumentUploadReminder(false);
        return;
      }
      if (isProfileStatusPendingDocuments) {
        setShowDocumentUploadReminder(true);
      }
    }, [isTransactionsEmpty, isProfileStatusPendingDocuments]);

    const handleOnClickCloseIcon = () => {
      setShowDocumentUploadReminder(false);
    };

    const handleOnClickToastMsg = () => {
      handleShowDocumentUploadReminderInformModal();
    };

    const renderDocumentUploadReminder = () => {
      if (!isShowDocumentUploadReminder) return null;
      return (
        <DocumentUploadReminderStyled>
          <ToastMsg
            dangerouslySetInnerHTML={{
              __html: t('label_upload_document_reminder_toast_message'),
            }}
            onClick={handleOnClickToastMsg}
          />
          <CloseIcon
            src={CloseWhiteIcon}
            width={24}
            height={24}
            onClick={handleOnClickCloseIcon}
          />
        </DocumentUploadReminderStyled>
      );
    };

    const newProps = {
      ...props,
    };
    return (
      <>
        {renderDocumentUploadReminder()}
        <Component {...newProps} />
      </>
    );
  };
  return ShowDocumentUploadReminderComponent;
};

const DocumentUploadReminderStyled = styled.div`
  position: fixed;
  top: 70px;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 52px;
  background: #1c89ac;
  padding-inline: 16px;
  display: flex;
  align-items: center;
  gap: 10px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    top: 72px;
    height: 40px;
    padding-inline: 50px;
  }
`;

const ToastMsg = styled.p`
  ${paragraph600Mixin};
  ${fontSize14Mixin};
  text-align: left;
  color: #fff;
  width: 100%;

  & span {
    text-decoration: underline;
    ${cursorPointerMixin};
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    ${fontSize16Mixin};
    text-align: center;
  }
`;
const CloseIcon = styled.img`
  ${cursorPointerMixin};
`;

export default withShowDocumentUploadReminder;
